import { useState } from 'react';
import useActAccountType from '../../../hooks/useActAccountType';
import { AccountType } from '../../../models';
import { api } from '../../../store/api';
import AccountSelect, { AccountSelectProps } from './AccountSelect';

interface LocalProps extends AccountSelectProps {}

const ActSelect = ({ ...props }: LocalProps) => {
    const accountType = useActAccountType();

    return <>{accountType && <InternalActSelect {...props} accountType={accountType} />}</>;
};

interface InternalProps extends AccountSelectProps {
    accountType: AccountType;
}

const InternalActSelect = ({ accountType, selectedAccountId, ...props }: InternalProps) => {
    const [searchString, setSearchString] = useState('');
    const { data: accounts } = api.usePerformerSearchQuery({ accountType, search: searchString }, { skip: searchString.length < 2 });
    const { data: selected } = api.useGetPerformerQuery(selectedAccountId ?? 0, { skip: !selectedAccountId });

    const fullProps = {
        ...props,
        searchString,
        accountType,
        selectedAccountId,
        setSearchString,
        accounts,
        selected,
    };

    return <AccountSelect {...fullProps} />;
};

export default ActSelect;
